const GET_CATEGORY_LIST_DATA = 'GET_CATEGORY_LIST_DATA';
const GET_CATEGORY_LIST_DATA_LOADING = 'GET_CATEGORY_LIST_DATA_LOADING';

export const TYPES_CATEGORY = { GET_CATEGORY_LIST_DATA, GET_CATEGORY_LIST_DATA_LOADING };
